<template>
  <div>
    <base-header type="gradient-default" class="pb-7 pt-5 pt-md-8"></base-header>
    <template v-if="entidade">
      <template v-if="entidade.ent_diario_html">
        <pesquisa-avancada></pesquisa-avancada>
      </template>
      <template v-else>
        <pesquisa-antiga></pesquisa-antiga>
      </template>
    </template>
  </div>
</template>
<script>

import PesquisaAvancada from "./Pesquisa/PesquisaAvancada"
import PesquisaAntiga from "./Pesquisa/PesquisaAntiga"

export default {
  components: {
    PesquisaAvancada,
    PesquisaAntiga
  },
  computed: {
    entidade() {
      return this.$store.getters.entidade;
    },
  },
};
</script>
<style></style>
